import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { Cookies } from './../index.js';
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import Language_i18 from './../js/useNationalLanguage.jsx';
import { useSelector } from 'react-redux';
import { isLocalHost } from './../shared/host_utils.js';

const SUPPORT_QUERY_BASE = 'app_structure.app_fontend.support_chat';

const normalizeDomain = (value) => String(value || '').trim().toLowerCase();

const filterLinksByDomain = (links, mainDomain) => {
    if (!Array.isArray(links)) return [];
    const currentDomain = normalizeDomain(mainDomain);
    return links.filter((link) => {
        const domainsRaw = link?.domain;
        if (!domainsRaw) return true;
        const domains = Array.isArray(domainsRaw) ? domainsRaw : [domainsRaw];
        return domains.map(normalizeDomain).includes(currentDomain);
    });
};

const resolveLinksByDomain = (mongoResults, mainDomain) => {
    if (Array.isArray(mongoResults)) {
        return filterLinksByDomain(mongoResults, mainDomain);
    }
    if (mongoResults && typeof mongoResults === 'object') {
        const domainKey = normalizeDomain(mainDomain);
        const keyedData = mongoResults[domainKey] || mongoResults[mainDomain];
        if (Array.isArray(keyedData)) return keyedData;
        if (Array.isArray(mongoResults.data)) {
            return filterLinksByDomain(mongoResults.data, mainDomain);
        }
    }
    return [];
};

const resolveLocalizedText = (value, lang) => {
    if (value == null) return '';
    if (typeof value === 'string' || typeof value === 'number') return String(value);
    if (typeof value === 'object') {
        return value?.[lang] || value?.en || value?.vi || '';
    }
    return '';
};

const NutHoTro = ({ open_button_support }) => {
    const latest_version = useSelector(state => state.latest_version);
    const { i18n, lang } = Language_i18();
    const national_market = Cookies.get('national_market') || 'en';
    const [isShowButton, setIsShowButton] = useState(false);
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const [hienDanhSach, setHienDanhSach] = useState(false);
    // Nút
    const hieuUngNut = useSpring({
        rotate: hienDanhSach ? 50 : 0,
        config: { tension: 180, friction: 16 },
    });

    // Danh sách
    const hieuUngDanhSach = useSpring({
        opacity: hienDanhSach ? 1 : 0,
        maxHeight: hienDanhSach ? 500 : 0,
        scale: hienDanhSach ? 1 : 0,
        config: { tension: 180, friction: 16 },
    });


    const chuyenDoiDanhSach = () => {
        if (hienDanhSach) {
            console.log('Danh sách đang hiển thị, thực hiện một hành động khác');
        }
        setHienDanhSach(!hienDanhSach);
    };
    const apikey = Cookies.get('apikey');

    useEffect(() => {
        if (open_button_support && !apikey) {
            switch_router('/shop/posts/tips_supports');
        }
    }, [open_button_support, apikey]);

    useEffect(() => {
        setHienDanhSach(open_button_support);
    }, [open_button_support]);

    useEffect(() => {
        try {
            const hostname = window.location.hostname || "";
            const isHustMediaDomain = hostname.includes("hust.media");

            if ((latest_version == 2 || latest_version == 3) && isHustMediaDomain) {
                setIsShowButton(false);
            } else {
                setIsShowButton(true);
            }
        } catch {
            setIsShowButton(true);
        }
    }, [latest_version]);
    const handleClick = (e, link) => {
        if (link.mode === "switch_router" && link.router) {
            e.preventDefault(); // Ngăn hành vi chuyển hướng mặc định của thẻ <a>
            switch_router(link.router); // Gọi hàm switch_router với đường dẫn được truyền vào
        }
    };
    const [links_support, set_links_support] = useState('');
    const getMainDomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        // Nếu có nhiều hơn 2 phần, lấy phần thứ hai từ cuối, ngược lại lấy phần đầu tiên
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };

    useEffect(() => {
        const main_domain = !isLocalHost(window.location.hostname)
            ? (Cookies.get("main_domain") || getMainDomain() || "hust")
            : (Cookies.get("main_domain") || "hust");
        const currentDomain = window.location.hostname;
        const key = 'support_chat';
        const time_update = 12 * 60 * 60 * 1000; // 12 tiếng
        const json_data = {
            query: SUPPORT_QUERY_BASE
        };

        const raw = localStorage.getItem(key);
        const store = raw ? JSON.parse(raw) : null;

        if (
            store &&
            Date.now() - store.timestamp < time_update &&
            JSON.stringify(store.payload) === JSON.stringify(json_data) &&
            !isLocalHost(currentDomain) && national_market == store.national_market
            && normalizeDomain(main_domain) === normalizeDomain(store.main_domain)
        ) {
            // Dữ liệu hợp lệ, không cần gọi API
            set_links_support(store.data);
            console.log('Loaded support chat links from cache.');
        } else {
            // Cache không hợp lệ: xóa cache và gọi API sau 2s
            localStorage.removeItem(key);
            console.log('Cache expired/missing or localhost — fetching support chat links.');

            const timer = setTimeout(() => {
                api_support_chat(json_data, key, main_domain);
            }, 2000);
            return () => clearTimeout(timer); // Dọn dẹp khi unmount
        }
    }, []);

    // Gọi API & lưu cache
    const api_support_chat = async (json_data, key, main_domain) => {
        const data = JSON.stringify(json_data);

        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://node_js.hust.media/main_1/mongo_1/api/mongo_get_query_api',
            headers: {
                'Content-Type': 'application/json'
            },
            data
        };

        try {
            const response = await axios.request(config);
            let results = resolveLinksByDomain(response?.data?.api_results?.mongo_results, main_domain);
            let payloadUsed = json_data;

            // Fallback cho cấu trúc cũ support_chat.<domain>
            if (!Array.isArray(results) || results.length === 0) {
                const legacyPayload = {
                    query: `${SUPPORT_QUERY_BASE}.${main_domain}`
                };
                const legacyConfig = {
                    ...config,
                    data: JSON.stringify(legacyPayload),
                };
                const legacyResponse = await axios.request(legacyConfig);
                results = resolveLinksByDomain(legacyResponse?.data?.api_results?.mongo_results, main_domain);
                payloadUsed = legacyPayload;
            }

            if (!Array.isArray(results)) return;
            set_links_support(results);

            const store = {
                timestamp: Date.now(),
                data: results,
                payload: payloadUsed,
                national_market: national_market,
                main_domain: main_domain,
            };
            localStorage.setItem(key, JSON.stringify(store));
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>

            {
                links_support && isShowButton && (
                    <>
                        <div className="fixed right-5 bottom-9 z-10">
                            <animated.button
                                style={{
                                    transform: hieuUngNut.rotate.to(r => `rotate(${r}deg)`),
                                }}
                                className="bg-pink-500 text-white rounded-full focus:outline-none"
                                onClick={chuyenDoiDanhSach}
                            >
                                <div className="text-center text-2xl mx-[0.75rem] py-2.5">💬</div>
                            </animated.button>

                            <animated.div
                                style={{
                                    ...hieuUngDanhSach,
                                    transform: hieuUngDanhSach.scale.to(s => `scale(${s})`),
                                }}
                                className="overflow-hidden absolute right-0 bottom-10 space-y-2"
                            >
                                {Array.isArray(links_support) && links_support.length > 0 && (
                                    <>
                                        <div>
                                            {links_support.map((link, index) => {
                                                if (link?.status !== "show") return null;
                                                return (
                                                    <a
                                                        key={index}
                                                        href={link.href || "#"}
                                                        target={link.target || ""}
                                                        onClick={(e) => handleClick(e, link)}
                                                        style={{ textDecoration: "none" }}
                                                    >
                                                        <div className="inline-block mb-2 bg-white border border-gray-300 p-2 rounded">
                                                            <button className="inline-block p-1 whitespace-nowrap text-blue-600 hover:text-blue-700 font-medium">
                                                                {resolveLocalizedText(link?.text, lang)}
                                                            </button>
                                                        </div>
                                                    </a>
                                                );
                                            })}
                                        </div>
                                    </>)
                                }

                            </animated.div>
                        </div>
                    </>
                )
            }

        </>
    );
};

export default NutHoTro;
